function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import RegionSelector from "../../../regions/RegionSelector";
import ComunaSelector from "../../../comunas/ComunaSelector";

var AddressInput = function AddressInput(props) {
  var address = props.address,
      disabled = props.disabled,
      _onChange = props.onChange,
      listRegions = props.listRegions,
      listComunas = props.listComunas,
      onDelete = props.onDelete,
      index = props.index,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
      _props$disableRemoveB = props.disableRemoveButon,
      disableRemoveButon = _props$disableRemoveB === void 0 ? false : _props$disableRemoveB;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row no-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, !hideLabel && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Direcci\xF3n"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    value: (address === null || address === void 0 ? void 0 : address.street) || "",
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, address), {}, {
        street: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, !hideLabel && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Regi\xF3n"), /*#__PURE__*/React.createElement(RegionSelector, {
    regions: listRegions,
    disabled: disabled,
    regionId: address === null || address === void 0 ? void 0 : address.region_id,
    onChange: function onChange(region_id) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, address), {}, {
        region_id: region_id
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, !hideLabel && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Comuna"), /*#__PURE__*/React.createElement(ComunaSelector, {
    comunas: listComunas,
    regionId: address === null || address === void 0 ? void 0 : address.region_id,
    disabled: disabled,
    comunaId: address === null || address === void 0 ? void 0 : address.comuna_id,
    onChange: function onChange(comuna_id) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, address), {}, {
        comuna_id: comuna_id
      }));
    }
  })), !disableRemoveButon && /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, !hideLabel && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "\xA0"), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-block",
    onClick: function onClick() {
      return onDelete && onDelete(index);
    }
  }, "-")));
};

export default AddressInput;